import React from 'react';
import './Label.scss';

function Label(props) {
    return <label className="form__label" htmlFor={props.to}>{props.title}</label>
}

export default Label;